/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Summer_TextInputs */



/**
* | output |
* | --- |
* | "Summer mode is forced all year round" |
*
* @param {Season_Summer_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_summer_text = /** @type {((inputs?: Season_Summer_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Summer_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer mode is forced all year round")
	return /** @type {LocalizedString} */ ("Le mode été est forcé toute l'année")
});